/**
 * Created by wjjn3481 on 2017/7/6.
 */

import InputCustom from './src/main'

InputCustom.install = function (Vue, options) {
    Vue.component(InputCustom.name, InputCustom)
}

export default InputCustom


// WEBPACK FOOTER //
// ./src/components/inputCustom/index.js